<template>
    <div class="shop-address-detail">
        <van-address-edit :show-area="false"
                          :address-info="addressInfo"
                          :show-delete="isUpdate"
                          show-set-default
                          @save="onSave"
                          @delete="onDelete" />
    </div>
</template>

<script>
import api_sale from '../../services/saleLogin.js';
import Vue from 'vue';
import { AddressEdit } from 'vant';
import areaList from '../../lib/area';

Vue.use(AddressEdit);

export default {
    name: 'shop-address-edit',
    data() {
        return {
            isUpdate: false,
            areaList: {},
            record: {},
            addressInfo: {
                name: null,
                tel: null,
                country: '',
                province: null,
                city: null,
                county: null,
                areaCode: null,
                addressDetail: null,
                isDefault: false,
            },
        };
    },
    computed: {
        showDel() {
            return !!this.record.id;
        },
    },
    created() {
        let query = this.$route.query;
        if (query.params) {
            this.isUpdate = true;
            this.parseParams(query.params);
        }
    },
    mounted() {
        // type : 1开单
        this.type = this.$route.query.type || null;

        this.areaList = areaList;
    },
    methods: {
        parseParams(params) {
            let temp = decodeURI(params);
            this.record = JSON.parse(temp);
            for (let key in this.record) {
                if (Reflect.has(this.addressInfo, key)) {
                    this.addressInfo[key] = this.record[key];
                }
            }
            this.addressInfo.addressDetail = this.record.address;
        },
        onDelete() {
            api_sale.delteUserAddress(this.record.id).then(
                (res) => {
                    this.$toast('已删除~');
                    this.$router.back();
                },
                (err) => {
                    this.$toast('删除失败~');
                }
            );
        },
        onSave(content) {
            let params = {
                patientId: this.$store.getters.getUserInfo.patientId,
                receiverPhone: content.tel,
                receiverName: content.name,
                receiverAddress: content.addressDetail,
                isDefault: content.isDefault ? 2 : 1,
            };
            // 更新
            if (this.record.id) {
                params.id = this.record.id;
                api_sale.updateUserAddress(params).then(
                    (res) => {
                        this.$router.back();
                    },
                    (err) => {
                        this.$toast('更新失败~');
                    }
                );
            } else {
                api_sale.saveUserAddress(params).then(
                    (res) => {
                        this.$toast('地址保存成功~');
                        if (this.type == 1) {
                            // 开单
                            params.id = res.data.data;
                            this.$store.commit('setOrderAddress', params);
                            this.$router.replace({
                                name: 'shoppingOrderDetail',
                                query: { type: this.type },
                            });
                        } else {
                            this.$router.back();
                        }
                    },
                    (err) => {
                        this.$toast('保存失败~');
                    }
                );
            }
        },
    },
};
</script>

<style lang='less'>
.shop-address-detail {
    min-height: 100vh;
    background: #f5f5f5;

    .van-button {
        &--danger {
            background: #208fe3;
            border-color: #208fe3;
        }
        border-radius: 10px;
    }
}
</style>